import React from "react";
import HistorialCambios from "../../components/HistorialCambios";

const HistorialUsuarios = () => (
  <HistorialCambios
    endpoint="/api/usuarios/historial"
    titulo="Historial de cambios — Usuarios"
    entidadLabel="Nombre"
    idLabel="Usuario"
    buscarPlaceholder="Nombre, usuario, editor..."
    volverA="/admin/usuarios"
    sugerenciasEndpoint="/api/usuarios/"
    sugerenciasCampo="user"
  />
);

export default HistorialUsuarios;
